import { Xmark } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text, TextInput } from "@gravity-ui/uikit";
import { useAction } from "@reatom/npm-react";
import { useCallback } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { Form } from "react-router-dom";
import { PhoneInput } from "src/pages/Authentificate/RegistrationPage/components/PhoneInput";
import { finalyRegistrationRequest } from "src/pages/Authentificate/store/fetchers";
import { getMeRequest } from "src/store/fetchers";

import { ChangeUserDataFormInput } from "../../ResponsiveChangeUserDataWidget.types";
import css from "./ChangeUserDataContent.module.scss";

interface ChangeUserDataContentProps {
  isModal?: boolean;
  isLoading?: boolean;
  hasPhone?: boolean;
  onClose: () => void;
}

export const ChangeUserDataContent = ({
  isModal,
  onClose,
  isLoading,
  hasPhone,
}: ChangeUserDataContentProps) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ChangeUserDataFormInput>({
    mode: "onChange",
  });

  const finalyRegistration = useAction(finalyRegistrationRequest);
  const getMe = useAction(getMeRequest);

  const onSubmit: SubmitHandler<ChangeUserDataFormInput> = useCallback(
    async (data) => {
      const phone = data?.phone?.replace(/[^\d+]/g, "");
      await finalyRegistration({ ...data, phone });
      await getMe();

      onClose();
    },
    [finalyRegistration, getMe, onClose],
  );

  return (
    <Flex direction="column" gap={1} style={{ padding: 20 }}>
      <Flex justifyContent={"space-between"}>
        <Text variant="subheader-3">Данные пользователя</Text>
        {isModal && (
          <Button view="flat" onClick={onClose}>
            <Icon data={Xmark} />
          </Button>
        )}
      </Flex>
      <br />

      <Form className={css.regForm} onSubmit={handleSubmit(onSubmit)}>
        <div className={css.regFormInputContainer}>
          <TextInput
            placeholder="Фамилия"
            {...register("lastName", {
              required: "Обязательное поле",
              minLength: {
                value: 4,
                message: "Минимальная длинна 4",
              },
              maxLength: { value: 30, message: "Максимальная длинна 30" },
            })}
            size="xl"
            label="Фамилия"
            type="text"
            validationState={errors.lastName ? "invalid" : undefined}
            errorMessage={errors.lastName?.message}
            errorPlacement="outside"
          />
        </div>
        <div className={css.regFormInputContainer}>
          <TextInput
            placeholder="Имя"
            {...register("firstName", {
              required: "Обязательное поле",
              minLength: {
                value: 4,
                message: "Минимальная длинна 4",
              },
              maxLength: { value: 30, message: "Максимальная длинна 30" },
            })}
            size="xl"
            label="Имя"
            type="text"
            validationState={errors.firstName ? "invalid" : undefined}
            errorMessage={errors.firstName?.message}
            errorPlacement="outside"
          />
        </div>
        <div className={css.regFormInputContainer}>
          <TextInput
            placeholder="Отчество"
            {...register("middleName", {
              minLength: {
                value: 4,
                message: "Минимальная длинна 4",
              },
              maxLength: { value: 30, message: "Максимальная длинна 30" },
            })}
            size="xl"
            label="Отчество"
            type="text"
            validationState={errors.middleName ? "invalid" : undefined}
            errorMessage={errors.middleName?.message}
            errorPlacement="outside"
          />
        </div>
        {!hasPhone && (
          <div className={css.regFormInputContainer}>
            <PhoneInput
              control={control}
              name="phone"
              errorMessage="Неверный формат номера телефона"
              required
            />
          </div>
        )}
        <Flex
          className={css.regFormInputContainer}
          direction={"column"}
          alignItems={"center"}
          gap={"3"}
        >
          <Button
            className={css.regButton}
            view="action"
            size="l"
            type="submit"
            width="max"
            loading={isLoading}
          >
            Завершить
          </Button>
        </Flex>
      </Form>
    </Flex>
  );
};
